import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { ArrowLeft, Building2, Mail, Upload } from 'lucide-react';
import { allCategories } from '../utils/partnersData';
const PartnerCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    website: '',
    email: '',
    description: '',
    categories: [] as string[],
    locations: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate partner creation
    alert(`Partner creato con successo!\n\nNome: ${formData.name}\nWebsite: ${formData.website}\nEmail: ${formData.email}\n\nUn'email di invito è stata inviata al partner.`);
    navigate('/partners');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleCategoryToggle = (category: string) => {
    setFormData({
      ...formData,
      categories: formData.categories.includes(category) ? formData.categories.filter(c => c !== category) : [...formData.categories, category]
    });
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2723">
      <div className="w-20 flex-shrink-0" data-id="element-2724">
        <Sidebar data-id="element-2725" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2726">
        <Topbar data-id="element-2727" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2728">
          {/* Back Button */}
          <button onClick={() => navigate('/partners')} className="flex items-center text-gray-600 hover:text-greenback mb-4 transition-colors" data-id="element-2729">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-2730" />
            Torna ai Partners
          </button>

          {/* Page Header */}
          <div className="mb-6" data-id="element-2731">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2732">
              Aggiungi Nuovo Partner
            </h1>
            <p className="text-gray-600" data-id="element-2733">
              Invita un nuovo partner sulla piattaforma Greenback
            </p>
          </div>

          {/* Form */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 max-w-3xl" data-id="element-2734">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2735">
              {/* Nome Partner */}
              <div data-id="element-2736">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2737">
                  Nome Partner <span className="text-red-500" data-id="element-2738">*</span>
                </label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Es. La Saponaria" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-2739" />
              </div>

              {/* Website e Email */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2740">
                <div data-id="element-2741">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2742">
                    Website <span className="text-red-500" data-id="element-2743">*</span>
                  </label>
                  <input type="url" name="website" value={formData.website} onChange={handleChange} required placeholder="https://www.example.it" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-2744" />
                </div>

                <div data-id="element-2745">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2746">
                    Email Contatto <span className="text-red-500" data-id="element-2747">*</span>
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="contatti@partner.it" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-2748" />
                </div>
              </div>

              {/* Descrizione */}
              <div data-id="element-2749">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2750">
                  Descrizione <span className="text-red-500" data-id="element-2751">*</span>
                </label>
                <textarea name="description" value={formData.description} onChange={handleChange} required rows={4} placeholder="Descrivi brevemente il partner e i suoi prodotti/servizi..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent resize-none" data-id="element-2752" />
              </div>

              {/* Numero Sedi */}
              <div data-id="element-2753">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2754">
                  Numero di Sedi
                </label>
                <input type="number" name="locations" value={formData.locations} onChange={handleChange} min="1" placeholder="Es. 5" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-2755" />
              </div>

              {/* Categorie */}
              <div data-id="element-2756">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-2757">
                  Categorie <span className="text-red-500" data-id="element-2758">*</span>
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-2759">
                  {allCategories.map(category => <label key={category} className="flex items-center gap-2 cursor-pointer" data-id="element-2760">
                      <input type="checkbox" checked={formData.categories.includes(category)} onChange={() => handleCategoryToggle(category)} className="w-4 h-4 text-greenback border-gray-300 rounded focus:ring-greenback" data-id="element-2761" />
                      <span className="text-sm text-gray-700" data-id="element-2762">{category}</span>
                    </label>)}
                </div>
                {formData.categories.length === 0 && <p className="text-sm text-red-500 mt-2" data-id="element-2763">
                    Seleziona almeno una categoria
                  </p>}
              </div>

              {/* Logo Upload */}
              <div data-id="element-2764">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2765">
                  Logo Partner
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-greenback transition-colors cursor-pointer" data-id="element-2766">
                  <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" data-id="element-2767" />
                  <p className="text-sm text-gray-600 mb-1" data-id="element-2768">
                    Clicca per caricare il logo
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2769">
                    PNG, JPG o SVG (max 2MB)
                  </p>
                  <input type="file" accept="image/*" className="hidden" id="logo-upload" data-id="element-2770" />
                </div>
              </div>

              {/* Info Box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-2771">
                <div className="flex items-start gap-3" data-id="element-2772">
                  <Mail className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-2773" />
                  <div data-id="element-2774">
                    <h4 className="font-semibold text-blue-900 mb-1" data-id="element-2775">
                      Email di Invito
                    </h4>
                    <p className="text-sm text-blue-700" data-id="element-2776">
                      Dopo aver creato il partner, verrà inviata automaticamente
                      un'email di invito con le istruzioni per accedere al
                      pannello partner di Greenback.
                    </p>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex gap-3 pt-4" data-id="element-2777">
                <button type="button" onClick={() => navigate('/partners')} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2778">
                  Annulla
                </button>
                <button type="submit" disabled={formData.categories.length === 0} className="flex items-center gap-2 px-6 py-2 bg-greenback text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2779">
                  <Building2 className="h-4 w-4" data-id="element-2780" />
                  Crea Partner e Invia Invito
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>;
};
export default PartnerCreate;